'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _glamorous2.default.table({
  borderCollapse: 'collapse'
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/components/dist/table/table.js
 ** module id = 576
 ** module chunks = 0
 **/